import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const QuickAccessLinks = () => {
  const supportLinks = [
    {
      icon: 'HelpCircle',
      title: 'Veelgestelde Vragen',
      description: 'Vind snel antwoorden op uw vragen',
      href: '/faq',
      color: 'text-primary'
    },
    {
      icon: 'MessageCircle',
      title: 'Live Chat Support',
      description: '24/7 beschikbaar voor hulp',
      href: '/support',
      color: 'text-success'
    },
    {
      icon: 'Phone',
      title: 'Bel Ons',
      description: '+31 20 123 4567',
      href: 'tel:+31201234567',
      color: 'text-secondary'
    },
    {
      icon: 'Mail',
      title: 'E-mail Support',
      description: 'support@verduurzaamwijzer.nu',
      href: 'mailto:support@verduurzaamwijzer.nu',
      color: 'text-accent'
    }
  ];

  const quickLinks = [
    {
      icon: 'Building',
      title: 'Voor Providers',
      description: 'Bent u een duurzaamheidsprovider?',
      href: '/provider-login',
      variant: 'provider'
    },
    {
      icon: 'Search',
      title: 'Diensten Zoeken',
      description: 'Bekijk beschikbare oplossingen',
      href: '/services',
      variant: 'services'
    }
  ];

  return (
    <div className="space-y-6">
      {/* Support Links */}
      <div className="bg-card rounded-lg shadow-elevation-1 p-6 border border-border">
        <div className="text-center mb-4">
          <h3 className="text-lg font-heading font-semibold text-foreground mb-2">
            Hulp Nodig?
          </h3>
          <p className="text-sm font-body text-muted-foreground">
            Ons team staat klaar om u te helpen
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {supportLinks?.map((link, index) => (
            <a
              key={index}
              href={link?.href}
              className="flex items-start space-x-3 p-3 rounded-md hover:bg-muted transition-micro group"
            >
              <div className="flex-shrink-0">
                <Icon 
                  name={link?.icon} 
                  size={20} 
                  className={`${link?.color} group-hover:scale-110 transition-transform`} 
                />
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="text-sm font-heading font-medium text-foreground mb-1">
                  {link?.title}
                </h4>
                <p className="text-xs font-body text-muted-foreground">
                  {link?.description}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
      {/* Quick Access Links */}
      <div className="bg-card rounded-lg shadow-elevation-1 p-6 border border-border">
        <div className="text-center mb-4">
          <h3 className="text-lg font-heading font-semibold text-foreground mb-2">
            Snelle Toegang
          </h3>
        </div>

        <div className="space-y-3">
          {quickLinks?.map((link, index) => (
            <Link
              key={index}
              to={link?.href}
              className="flex items-center space-x-3 p-3 rounded-md border border-border hover:border-primary hover:bg-primary/5 transition-micro group"
            >
              <div className="flex-shrink-0">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center ${
                  link?.variant === 'provider' ? 'bg-secondary/10' : 'bg-primary/10'
                }`}>
                  <Icon 
                    name={link?.icon} 
                    size={18} 
                    color={link?.variant === 'provider' ? 'var(--color-secondary)' : 'var(--color-primary)'} 
                  />
                </div>
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="text-sm font-heading font-medium text-foreground mb-1">
                  {link?.title}
                </h4>
                <p className="text-xs font-body text-muted-foreground">
                  {link?.description}
                </p>
              </div>
              <Icon 
                name="ChevronRight" 
                size={16} 
                className="text-muted-foreground group-hover:text-primary transition-micro" 
              />
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default QuickAccessLinks;